export function extractAssistantText(data) {
  if (data == null) {
    return '';
  }
  if (typeof data === 'string') {
    return data;
  }
  const d = data;
  const nested = d.data && typeof d.data === 'object' ? d.data : null;
  const pick =
    d.message ||
    d.reply ||
    d.content ||
    d.text ||
    (nested && (nested.message || nested.reply || nested.content));
  if (typeof pick === 'string') {
    return pick;
  }
  return '';
}

export function extractSettingsPayload(data) {
  if (data == null || typeof data !== 'object') {
    return { enabled: false };
  }
  const d = data.data && typeof data.data === 'object' ? data.data : data;
  if (typeof d.enabled === 'boolean') {
    return { enabled: d.enabled };
  }
  if (typeof d.aiChatEnabled === 'boolean') {
    return { enabled: d.aiChatEnabled };
  }
  return { enabled: Boolean(d.enabled) };
}
